import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { BookOpen, Lock, Mail, CheckCircle2, ArrowRight, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { formatApiError } from "../../lib/apiError";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const RegistrationClosed = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [done, setDone] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${BACKEND_URL}/api/waitlist`, { email: email.trim(), name: name.trim() || null });
      setDone(res.data);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail, "No pudimos guardar tu correo"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="registration-closed" className="space-y-6">
      <div className="text-center space-y-3">
        <div className="mx-auto w-16 h-16 rounded-full bg-brand-lightBlue flex items-center justify-center">
          <Lock className="w-7 h-7 text-brand-blue" />
        </div>
        <h2 className="text-lg md:text-xl font-bold text-brand-dark">Por el momento no es posible registrarse</h2>
        <p className="text-gray-500 text-sm leading-relaxed">Estamos afinando la siguiente etapa de Appadrino para que más familias puedan ahorrar juntas. Déjanos tu correo y te avisaremos en cuanto abramos nuevas cuentas.</p>
      </div>

      {done ? (
        <div data-testid="waitlist-success" className="rounded-2xl bg-brand-lightGreen p-5 text-center space-y-2">
          <CheckCircle2 className="w-8 h-8 text-brand-green mx-auto" />
          <p className="font-bold text-brand-dark">{done.status === "already_registered" ? "Ya estabas en la lista" : "¡Listo, estás en la lista!"}</p>
          <p className="text-sm text-gray-600">{done.message}. Revisa tu correo.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-3" data-testid="waitlist-form">
          <Input data-testid="waitlist-name-input" placeholder="Tu nombre (opcional)" value={name} onChange={(e) => setName(e.target.value)} className="h-12 rounded-xl" />
          <div className="relative">
            <Mail className="w-4 h-4 text-gray-400 absolute left-4 top-1/2 -translate-y-1/2" />
            <Input required type="email" data-testid="waitlist-email-input" placeholder="tucorreo@ejemplo.com" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl pl-11" />
          </div>
          <Button type="submit" disabled={loading} data-testid="waitlist-submit-btn" className="w-full h-12 bg-brand-blue hover:bg-brand-blue/90 text-white font-bold rounded-xl">
            {loading ? "Guardando..." : "Avísenme cuando abran"} <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </form>
      )}

      <div className="rounded-2xl border border-gray-100 bg-gray-50 p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="blog-cta">
        <div className="w-11 h-11 rounded-xl bg-brand-green/30 flex items-center justify-center shrink-0">
          <BookOpen className="w-5 h-5 text-brand-dark" />
        </div>
        <div className="flex-1">
          <p className="font-bold text-brand-dark text-sm flex items-center gap-1"><Sparkles className="w-3.5 h-3.5 text-brand-blue" /> Mientras tanto, aprende a ahorrar en familia</p>
          <p className="text-xs text-gray-500">Tips de finanzas familiares, becas y educación financiera para tus hijos.</p>
        </div>
        <Link to="/educacion">
          <Button variant="outline" data-testid="blog-cta-btn" className="rounded-full border-brand-blue text-brand-blue font-bold hover:bg-brand-lightBlue">Ir al blog</Button>
        </Link>
      </div>

      <p className="text-center text-sm text-gray-500">¿Ya tienes cuenta? <Link to="/login" data-testid="register-login-link" className="text-brand-blue font-bold hover:underline">Inicia sesión aquí</Link></p>
    </div>
  );
};
